import React from "react";

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, description }) => {
   
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-1000 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6">
        <h2 className="text-lg font-semibold mb-2">{title || "Are you sure?"}</h2>
        <p className="text-sm text-gray-600 mb-4">
          {description || "This action cannot be undone."}
        </p>
        <div className="flex justify-end gap-2">
          <button
            className="px-4 py-2 rounded border border-gray-300 hover:bg-gray-100"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 rounded bg-red-500 text-white hover:bg-red-600"
            onClick={onConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;

// import React from "react";
// import {
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Button,
// } from "reactstrap";

// const ConfirmModal = ({ 
//   isOpen, 
//   onClose, 
//   onConfirm, 
//   title, 
//   description,
//   confirmText = "Delete",
//   cancelText = "Cancel",
//   confirmColor = "danger"
// }) => {
//   return (
//     <Modal 
//       isOpen={isOpen} 
//       toggle={onClose}
//       centered
//       style={{ zIndex: 1060 }}
//       backdrop="static"
//     >
//       <ModalHeader toggle={onClose}>
//         {title || "Are you sure?"}
//       </ModalHeader>
//       <ModalBody>
//         <p className="mb-0">
//           {description || "This action cannot be undone."}
//         </p>
//       </ModalBody>
//       <ModalFooter>
//         <Button 
//           color="secondary" 
//           onClick={onClose}
//           className="cancel_Btn"
//         >
//           {cancelText}
//         </Button>
//         <Button 
//           color={confirmColor}
//           onClick={onConfirm}
//         >
//           {confirmText}
//         </Button>
//       </ModalFooter>
//     </Modal>
//   );
// };

// export default ConfirmModal;
